import React from "react";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import { Box } from "grid-styled";
import CenteredLoader from "./CenteredLoader";
import FranchiseStaffList from "./FranchiseStaffList";
import { deleteFromCache } from "../utils/queryHelpers";

const FranchiseStaff = ({
  franchiseId,
  updateFranchiseMembership,
  deleteFranchiseMembership,
  resendUserInvitation,
  data: { loading, error, franchiseMemberships }
}) => {
  if (loading) return <CenteredLoader />;
  if (error) return "Error.";

  return (
    <Box pt={2}>
      <FranchiseStaffList
        updateFranchiseMembership={updateFranchiseMembership}
        deleteFranchiseMembership={deleteFranchiseMembership}
        franchiseMemberships={franchiseMemberships}
        franchiseId={franchiseId}
        reinviteUser={resendUserInvitation}
        style={{ borderTop: 0 }}
      />
    </Box>
  );
};

export const FRANCHISE_MEMBERSHIPS_QUERY = gql`
  query FranchiseMemberships($franchiseId: ID!) {
    franchiseMemberships(franchiseId: $franchiseId) {
      id
      owner
      trackAsSalesperson
      canSubmitJobs
      user {
        id
        name
        email
        invitationTokenRedeemed
      }
    }
  }
`;

const UPDATE_FRANCHISE_MEMBERSHIP_MUTATION = gql`
  mutation UpdateFranchiseMembership(
    $id: ID!
    $input: FranchiseMembershipInput!
  ) {
    updateFranchiseMembership(id: $id, input: $input) {
      id
      owner
      trackAsSalesperson
      canSubmitJobs
      user {
        id
        name
        email
        invitationTokenRedeemed
      }
    }
  }
`;

const DELETE_FRANCHISE_MEMBERSHIP_MUTATION = gql`
  mutation DeleteFranchiseMembership($id: ID!) {
    deleteFranchiseMembership(id: $id) {
      id
      owner
      trackAsSalesperson
      canSubmitJobs
      user {
        id
        name
        email
        invitationTokenRedeemed
      }
    }
  }
`;

const RESEND_USER_INVITATION = gql`
  mutation ResendUserInvitation($id: ID!) {
    resendUserInvitation(id: $id) {
      id
      name
      email
      invitationTokenRedeemed
    }
  }
`;

const enhance = compose(
  graphql(FRANCHISE_MEMBERSHIPS_QUERY, {
    options: ({ franchiseId }) => ({
      variables: { franchiseId }
    }),
    skip: ({ franchiseId }) => !franchiseId
  }),
  graphql(RESEND_USER_INVITATION, {
    props: ({ mutate }) => ({
      resendUserInvitation: ({ id }) => {
        return mutate({ variables: { id } });
      }
    })
  }),
  graphql(UPDATE_FRANCHISE_MEMBERSHIP_MUTATION, {
    props: ({ mutate }) => ({
      updateFranchiseMembership: ({ id, input }) => {
        return mutate({
          variables: { id, input }
        });
      }
    })
  }),
  graphql(DELETE_FRANCHISE_MEMBERSHIP_MUTATION, {
    props: ({ mutate, ownProps: { franchiseId } }) => ({
      deleteFranchiseMembership: ({ id }) => {
        return mutate({
          variables: { id },
          update: store => {
            deleteFromCache(id, store, "franchiseMemberships", {
              query: FRANCHISE_MEMBERSHIPS_QUERY,
              variables: { franchiseId }
            });
          }
        });
      }
    })
  })
);

export default enhance(FranchiseStaff);



// WEBPACK FOOTER //
// ./src/components/FranchiseStaff.js